import React, { useState, Fragment, useContext } from "react";
import "./authentication.css"
import Button from "../../components/Button/button";
import TextInput from "../../components/TextInput/textInput"
import ForgotPassword from "../../components/ForgotPassword/forgotPassword"
import ToastContext from "../../Context/toastContext"
import useRenderCount from "../../renderCountHook"
import { validateEmail } from "../../utility"
import Loader from "../../components/Loader/loader"
import apiRequest from "../../api";
import SignUp from "./signup";
import LogIn from "./login";
import StringConstant from '../../stringConstant'
import { useTranslation } from "react-i18next";

const ASK_EMAIL = "ASK_EMAIL";
const SING_IN = "SING_IN";
const SIGN_UP = "SIGN_UP";

const LoginEmail = props => {
   useRenderCount("LOGIN")
   const [View, setView] = useState(ASK_EMAIL);
   const [email, setEmail] = useState("");
   const [showLoader, setShowLoader] = useState(false);
   const { setMessage } = useContext(ToastContext);
   const { t } = useTranslation();

   const askEmail = () => {
      setView(ASK_EMAIL)
      setEmail('')
   }
   //--API call for user authentication--//
   const pokeAPI = async () => {
      setShowLoader(true)
      try {
         if (View === ASK_EMAIL) {
            const response = await apiRequest(`users/check_email?email=${email}`, undefined, undefined, setMessage);
            setShowLoader(false)
            if (response) {
               if (response.exists) {
                  setView(SING_IN)
               } else {
                  setView(SIGN_UP)
               }
            }
         }
      } catch (e) {
         setMessage(e.message)
      }
   }
   //--Conditional rendering for login, signup and forgot password--//
   const renderInput = () => {
      if (View === ASK_EMAIL) {
         return (
            <div className="row h-100 justify-content-center align-items-center login-inner">
               <div className="col-12">
                  <TextInput name="email" title={t(StringConstant.labelEnterEmail)} type="email"
                     value={email}
                     onChange={(e) => setEmail(e.target.value)} />
                  <div className="col-12">
                     {
                        <Button disabled={!validateEmail(email)} btnClick={pokeAPI} title={t(StringConstant.labelSubmit)} />
                     }
                     <ForgotPassword email={email} />
                  </div>
               </div>
            </div>
         )
      } else if (View === SING_IN) {
         return (
            <LogIn email={email} setShowLoader={setShowLoader} askEmail={askEmail} />
         )
      } else if (View === SIGN_UP) {
         return (
            <SignUp email={email} setShowLoader={setShowLoader} askEmail={askEmail} />
         )
      }
   }

   return (
      <Fragment>
         {showLoader && <Loader />}
         <div className="login-body" id="login-body">
            <div className="row">
               {renderInput()}
            </div>
         </div>
      </Fragment>

   )
}

export default LoginEmail;